import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ItemStatus } from "@focus/focusUI";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError, of } from "rxjs";

const baseURL = "/api/v1/bahn";

const initialState: any = {
  config: undefined,
  data: undefined,
  status: ItemStatus.READY,
  error: null,
};

const BahnPlotSlice = createSlice({
  name: "bahn-plot",
  initialState,
  reducers: {
    getBahnPlotRequest(state, _action) {
      state.status = ItemStatus.PENDING;
      state.error = null;
    },
    getBahnPlotSuccess(state, action: PayloadAction<any>) {
      state.status = ItemStatus.READY;
      state.data = action.payload.data;
      state.config = action.payload.config;
    },
    getBahnPlotFailure(state, action: PayloadAction<string>) {
      state.status = ItemStatus.ERROR;
      state.error = action.payload;
    },
  },
});

export const { getBahnPlotRequest, getBahnPlotSuccess, getBahnPlotFailure } =
  BahnPlotSlice.actions;

const getBahnPlotEpic = (action, _state, { ajax }) => {
  return action.pipe(
    ofType(getBahnPlotRequest.type),
    mergeMap(
      (
        action: PayloadAction<{
          id: number;
        }>
      ) => {
        const { id } = action.payload;
        return ajax.getJSON(`${baseURL}/${id}`).pipe(
          map((response: any) => getBahnPlotSuccess(response)),
          catchError((error) => {
            return of(
              getBahnPlotFailure(error.message || "Error fetching api keys")
            );
          })
        );
      }
    )
  );
};

export default {
  actions: BahnPlotSlice.actions,
  reducer: BahnPlotSlice.reducer,
  middleware: [getBahnPlotEpic],
  selectors: BahnPlotSlice.selectors,
};
